import { svg } from '@rxdi/lit-html';

export const Invitation = svg`
<?xml version="1.0" encoding="iso-8859-1" ?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg width="45" height="45" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
	<path style="fill:#96C8EF;" d="M279.948,7.379c-14.45-9.838-33.448-9.838-47.897,0L22.785,149.858
	c-9.864,6.716-15.767,17.877-15.767,29.809v307.231c-0.001,13.863,11.237,25.101,25.1,25.101h447.763
	c13.863,0,25.1-11.238,25.1-25.1V179.668c0-11.934-5.903-23.094-15.767-29.809L279.948,7.379z" />
	<path style="fill:#78B9EB;" d="M479.88,511.999c13.863,0,25.1-11.238,25.1-25.1V179.668c0-11.933-5.903-23.094-15.767-29.81
	l-42.065-28.64L269.174,228.934c-3.975,2.4-8.532,3.671-13.176,3.671c-4.601,0-9.114-1.245-13.064-3.603L65.809,120.565
	l-43.024,29.293c-9.864,6.716-15.767,17.877-15.767,29.81v307.231c-0.001,13.862,11.237,25.1,25.1,25.1H479.88z" />
	<path style="fill:#FFF5CC;" d="M441.582,430.859H70.416V101.983c0-23.355,18.934-42.289,42.289-42.289h286.588
	c23.355,0,42.289,18.934,42.289,42.289L441.582,430.859L441.582,430.859z" />
	<path style="fill:#FFEB99;" d="M269.175,228.935c-3.975,2.4-8.532,3.671-13.176,3.671c-4.601,0-9.114-1.245-13.064-3.603
	L70.416,123.385v307.474h371.165V124.588L269.175,228.935z" />
	<path style="fill:#B9D8F4;" d="M210.871,281.846L12.579,160.451c-3.575,5.675-5.561,12.314-5.561,19.217v307.231
	c-0.001,13.862,11.237,25.1,25.1,25.1h447.763c13.863,0,25.1-11.238,25.1-25.1V179.668c0-6.498-1.762-12.76-4.949-18.207
	L301.127,281.846C273.375,298.605,238.623,298.605,210.871,281.846z" />
	<path style="fill:#D1E7F8;" d="M213.301,283.365L17.908,507.719c4.004,2.702,8.83,4.28,14.023,4.28h447.763
	c5.358,0,10.319-1.684,14.396-4.544L299.044,282.947C272.492,298.088,239.96,298.233,213.301,283.365z" />
	<g>
		<path style="fill:#57565C;" d="M369.614,120.204H142.385c-4.267,0-7.726-3.458-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726
		h227.228c4.267,0,7.726,3.458,7.726,7.726C377.339,116.746,373.881,120.204,369.614,120.204z" />
		<path style="fill:#57565C;" d="M369.614,160.304H142.385c-4.267,0-7.726-3.458-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726
		h227.228c4.267,0,7.726,3.458,7.726,7.726C377.339,156.846,373.881,160.304,369.614,160.304z" />
		<path style="fill:#57565C;" d="M249.002,200.402H142.385c-4.267,0-7.726-3.458-7.726-7.726c0-4.268,3.459-7.726,7.726-7.726
		h106.618c4.267,0,7.726,3.458,7.726,7.726C256.729,196.943,253.269,200.402,249.002,200.402z" />
	</g>
	<path style="fill:#3E3D42;" d="M142.385,200.402h53.834l-25.242-15.453h-28.593c-4.267,0-7.726,3.458-7.726,7.726
	C134.658,196.943,138.118,200.402,142.385,200.402z" />
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
	<g></g>
</svg>
`;
